import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output, inject, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';

import { ENVIRONMENT } from '@environment';
import { LocationService } from '@usheru-hff/sdk/location';
import { Country } from '@usheru-hff/shared/domain';
import { SharedUtilsTranslationModule, TranslationsService } from '@usheru-hff/shared/utils-translation';

@Component({
  selector: 'feature-streaming-country-selector',
  standalone: true,
  imports: [CommonModule, DropdownModule, FormsModule, SharedUtilsTranslationModule],
  templateUrl: './feature-streaming-country-selector.component.html',
  styleUrl: './feature-streaming-country-selector.component.scss'
})
export class FeatureStreamingCountrySelectorComponent implements OnInit, OnDestroy {
  private readonly env = inject(ENVIRONMENT);
  private readonly locationService = inject(LocationService);
  private readonly translationsService = inject(TranslationsService);
  private cd = inject(ChangeDetectorRef);

  /**
   * !NOTE The default value should be null (or this input should not exist). This
   * was this default to don't cause changes in the apps.
   */
  dropdownIcon = input<string | null>('chevron-arrow-down');

  country?: Country;
  countries: Country[] = [];
  unsubscribe = new EventEmitter();

  @Output() countryChanged: EventEmitter<Country> = new EventEmitter<Country>();

  ngOnInit(): void {
    this.countries = this.locationService.getAvailableCountries();
    this.countries.forEach(c => (c.trMsg = this.translationsService.translate(c.trMsg, c.name)));
    this.country = this.locationService.getAvailableCountrySelected(this.countries);
    this.listenForCountryChanges();
  }

  changeCountry(contry: Country) {
    this.country = contry;
  }

  onCountryChanged() {
    if (this.country) {
      this.locationService.selectedCountry = this.country;
      this.countryChanged.emit(this.country);
    }
  }

  listenForCountryChanges() {
    this.locationService.$countryChanged.pipe().subscribe(country => {
      const countryTrKey = this.locationService.selectedCountry.trMsg;
      country.trMsg = this.translationsService.translate(countryTrKey);
      this.country = country;
      this.cd.detectChanges();
    });
  }

  onEnterItem(event: any) {
    if (event.key === 'Enter') {
      event.target.click();
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe.emit();
  }
}
